import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import { BrowserHistoryEvent } from "web/script/utils/history";
import storage from "web/script/utils/storage";

type OverlayDecision = "open" | "close";

export function getOverlayDecision(
    urlData: BrowserHistoryEvent | null,
    isOverlayOpen: boolean
): OverlayDecision | void {
    if (!urlData) {
        return;
    }

    // if nothing has changed in the URL, do nothing
    if (
        urlData?.newURL.pathname === urlData?.oldURL?.pathname &&
        urlData?.queryChanges?.length === 0 &&
        urlData.newURL.hash === urlData.oldURL?.hash
    ) {
        return;
    }

    if (urlData.state?.overlay !== "related-products-overlay" && isOverlayOpen) {
        return "close";
    }

    if (urlData.state?.overlay === "related-products-overlay") {
        return "open";
    }

    return;
}

export function handlePageAnalytics(productData): void {
    const overlayOnInitialPageLoad = storage.get("overlayOnInitialPageLoad", false, true);
    const initialPageURL = storage.get("initialPageURL", "", true);

    // ORG-3513: Correctly set up analytics data
    // if the initial page load opens product overlay
    // see https://confluence.lystit.com/display/OA/FY23+Q2+-+Hash+URL+Crawl+Optimisation for more details
    if (overlayOnInitialPageLoad && initialPageURL === window.location.href) {
        analytics.setInitialPageType("product_overlay");
        analytics.setInitialSubPageType(`${productData?.in_stock ? "in_stock" : "out_of_stock"}`);
    }

    const {
        ga_variables: gaVariables,
        product_analytics_data: analyticsProduct,
        product_page_view_analytics: pageViewAnalytics,
        product_url: productURL,
    } = productData;

    // update environment variables
    environment.set({
        pageType: "product_overlay",
        pageSubType: productData.in_stock ? "in_stock" : "out_of_stock",
        gaVariables,
        analyticsProduct,
        pageViewAnalytics,
        productURL,
    });

    analytics.pageView();
}

export function getProductSlugFromPath(url?: URL): string | undefined {
    if (!url) {
        return;
    }
    const parts = url.pathname.split("/");

    return parts[parts.length - 2];
}
